export const awardData = [
  {
    id: 'felicis-hackathon',
    title: "Winner of Felicis Fellows Hackathon",
    date: 'June 2026',
    organization: 'Felicis',
    image: '/images/awards/felicis.jpg',
    explanation: "This award was presented by Felicis Partners and founders for technical difficulty, pitch, and market fit. I was awarded $25,000 for building security harnesses for 50 parallel RL environments to protect them from prompt injections."
  },
  {
    id: 'edinburgh-exchange',
    title: "International Experience Scholarship",
    date: 'Jan 2026',
    organization: 'University of Waterloo',
    image: '/images/awards/europe.jpg',
    explanation: "A $2500 scholarship given to students participating in an international experience. I was awarded this scholarship to study abroad at Heriot-Watt University (Edinburgh, UK)."
  },
  {
    id: 'kp-hackathon-win',
    title: "Winner of KP Fellows Hackathon",
    date: 'July 2025',
    organization: 'Kleiner Perkins',
    image: '/images/awards/kphackathon.png',
    explanation: 'This award was presented by Dan Li, the CEO of Nooks AI, who chose the project with the most technical depth and product vision. In other words, he selected the project that he would have most likely invested in.'
},
{
    id: 'technova-win',
    title: "Best Hack for Female Empowerment",
    date: 'Nov 2024',
    organization: 'TechNova 2024',
    image: '/images/awards/technova.png',
    explanation: 'This award is given to the best hack aimed at creating a diverse and inclusive project.'
},
  {
    id: 'presidents-scholarship',
    title: "President's Scholarship of Distinction",
    date: 'Sept 2023',
    organization: 'University of Waterloo',
    image: '/images/awards/waterloo.png',
    explanation: 'A $2000 scholarship awarded by the University of Waterloo to recognize admitted students with a 95%+ admissions average.'
  },
  {
    id: 'badminton-mvp',
    title: 'Senior Badminton MVP Award',
    date: 'June 2023',
    organization: 'Merivale High School',
    image: '/images/awards/mvp.png',
    explanation: 'The Senior Badminton MVP Award is given to the recipient who performed at the highest level during the competitive badminton season. Winning both the Mixed and Girls Doubles categories, I qualified myself for OFSAA in both 2022 and 2023.'
  },
  {
    id: 'first-impact',
    title: 'FIRST IMPACT Award',
    date: 'March 2023',
    organization: 'FIRST Robotics',
    image: '/images/awards/impact.jpg',
    explanation: 'The FIRST Impact Award is the most prestigious award at FIRST, it honors the team that best represents a model for other teams to emulate and best embodies the mission of FIRST. My team, 2706 Merge Robotics, received the IMPACT award at the Humber College event during the 2022-2023 season.'
  },
  {
    id: 'owg-second',
    title: 'Ontario Winter Games - 2nd Place',
    date: 'Feb 2023',
    organization: 'Badminton Ontario',
    image: '/images/awards/owg.png',
    explanation: 'The Ontario Winter Games is the largest multi-sport event in the province and feature over 3,500 athletes, coaches, managers, and major officials. I competed as a badminton athlete representing Team Ottawa.'
  },
  {
    id: 'lunarhacks-health',
    title: 'Best Health Hack',
    date: 'Dec 2022',
    organization: 'LunarHacks II',
    image: '/images/awards/lunarhacks.png',
    explanation: 'A prestigious award given to the team who created the most innovative project that improves physical, mental and social well-being during LunarHacks II.'
  },
  {
    id: 'odba-athlete',
    title: 'U19 Athlete of the Year',
    date: 'Jun 2020',
    organization: 'ODBA',
    image: '/images/awards/odba.png',
    explanation: 'Athlete of the Year recognizes the player who has accumulated the most ranking points throughout the competitive season in the singles, doubles, and mixed doubles events.'
  }
];
